import { render, staticRenderFns } from "./SwitchFreeCancel.vue?vue&type=template&id=50b92621&"
import script from "./SwitchFreeCancel.vue?vue&type=script&lang=js&"
export * from "./SwitchFreeCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports